const initialAccessUrlKey = "initial_access_url";

export function setInitialAccessUrl() {
  const original = getInitialAccessUrl();
  if (original) {
    // check if utm_source exists and is not equal to original
    const utmSource = getUtmSourceFromUrl();
    if (utmSource && utmSource !== getUtmSourceFromUrl(original)) {
      // set new initial access url
      localStorage?.setItem(initialAccessUrlKey, getCurrentUrl());
    }
  } else {
    // set initial access url when it is not set
    localStorage?.setItem(initialAccessUrlKey, getCurrentUrl());
  }
}

export function getInitialAccessUrl(): string | null {
  return localStorage?.getItem(initialAccessUrlKey);
}

function getCurrentUrl(): string {
  return window.location.href;
}

function getUtmSourceFromUrl(url?: string): string | null {
  const obj = new URL(url || getCurrentUrl());
  return obj.searchParams.get("utm_source");
}
